/**
 * Module-level store for the active MSAL account.
 *
 * The axios interceptor needs the current MSAL account to call
 * `acquireTokenSilent`, but it cannot use React hooks. `MsalAuthWrapper`
 * registers the account here synchronously (before any await) so the
 * interceptor always has an account to work with — including for the very
 * first request (`/authorize`) issued during the auth bootstrap.
 */
let activeAccount = null;

export const setMsalAccount = (account) => {
  activeAccount = account;
};

export const getMsalAccount = () => activeAccount;
